import React from 'react';
import IconButton from 'plaid-threads/IconButton';
import Cancel from 'plaid-threads/Icons/Cancel';

// #TODO: If I use the wrapped component instead, the ID gets all weird.
// How do I fix that?
import { TextInput } from 'src/components/Inputs';

import styles from './ChatInput.module.scss';

interface ChatInputProps {
  currentQuestion: string;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isStreaming: boolean;
  handleStopStream: () => void;
  isEmptyState: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({
  currentQuestion,
  onInputChange,
  isStreaming,
  handleStopStream,
  isEmptyState,
}) => {
  return (
    <div className={styles.chatInput} id='finn-input-div'>
      <TextInput
        autoComplete='off'
        className={styles.input}
        id='finn-input'
        name='finn-input'
        placeholder={
          isEmptyState ? 'Ask a question...' : 'Ask another question...'
        }
        label={isEmptyState ? 'Ask a question...' : 'Ask another question...'}
        value={currentQuestion}
        onChange={onInputChange}
        iconButtons={[
          isStreaming && (
            <IconButton
              accessibilityLabel='Clear search input'
              hideTooltip={true}
              icon={<Cancel className={styles.inputIcon} />}
              onClick={handleStopStream}
            />
          ),
        ]}
      />
    </div>
  );
};

ChatInput.displayName = 'ChatInput';

export default ChatInput;
